const setLoadingExportPdfAction = ({ commit }, payload) => {
  commit('loadingExportPdfV2', payload)
}

const setLoadingExportImageAction = ({ commit }, payload) => {
  commit('loadingExportImage', payload)
}

const setLoadingExportExcelAction = ({ commit }, payload) => {
  commit('loadingExportExcelV2', payload)
}

const setLoadingExportExcelActionV5 = ({ commit }, payload) => {
  commit('loadingExportExcelV5', payload)
}

export default {
  setLoadingExportPdfAction,
  setLoadingExportImageAction,
  setLoadingExportExcelAction,
  setLoadingExportExcelActionV5,
}
